// @greenlight-spec: 28-it-dashboard-ui.md
// @greenlight-spec: 09-data-brokering.md
import * as React from 'react';

import { cn } from '@/lib/utils';

// Renders the bound credential handle (the `integration_credentials.slug` a grant
// binds on). There is no read/write/access risk ramp: a credential's capability is
// free text IT authors in the external system, so the platform cannot infer risk
// from the slug (docs/09 § Integration credentials & grants). The chip stays neutral
// and never competes with the status color (color = status).
export function CredentialChip({
  slug,
  className,
}: {
  slug: string;
  className?: string;
}): React.JSX.Element {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-gl px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-[0.06em]',
        'font-medium text-muted-foreground',
        className,
      )}
    >
      {slug.toUpperCase()}
    </span>
  );
}
